export const SITE_BASE_URL = 'https://floricultura.moraiskaua.com.br'

export const SITE_NAME = 'Flora Ateliê'

export const SITE_DEFAULT_TITLE = 'Flora Ateliê — Floricultura-ateliê de luxo'

export const SITE_DEFAULT_DESCRIPTION =
  'Floricultura-ateliê de luxo com buquês autorais e entrega cuidadosa. Fale por e-mail e receba flores com o cuidado da Flora Ateliê.'
